/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type documents_UploadSubsidyDocumentRequest = {
    /**
     * Category is one of the seven subsidy document categories.
     */
    category: documents_UploadSubsidyDocumentRequest.category;
    /**
     * FileID is the confirmed upload (PDF, JPEG or PNG).
     */
    file_id: string;
    /**
     * ValidFrom (YYYY-MM-DD): only for bf_confirmation, sbu_confirmation, kmbb_fachstelle, kmbb_standortgespraech.
     */
    valid_from?: string;
    /**
     * ValidUntil (YYYY-MM-DD, inclusive): same categories as ValidFrom; empty = does not expire.
     */
    valid_until?: string;
};
export namespace documents_UploadSubsidyDocumentRequest {
    /**
     * Category is one of the seven subsidy document categories.
     */
    export enum category {
        BF_CONFIRMATION = 'bf_confirmation',
        SBU_CONFIRMATION = 'sbu_confirmation',
        FINANZIERUNGSANTRAG = 'finanzierungsantrag',
        ELTERNVEREINBARUNG = 'elternvereinbarung',
        SUBSIDY_DECISION = 'subsidy_decision',
        KMBB_FACHSTELLE = 'kmbb_fachstelle',
        KMBB_STANDORTGESPRAECH = 'kmbb_standortgespraech',
    }
}

